import { features } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-star-line"></i>
            <span>为什么选择我们</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">平台优势</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            五大核心优势，打造极致的免费漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200/60 transition-colors duration-200 text-center group cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100/60 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}